import { lazy, Suspense, useMemo, useCallback } from 'react'
import { useAtomValue } from 'jotai'
import {
  nextHardStartCueIdAtom,
  firstCueIdAtom,
  rundownAtom,
  cuesAtom,
} from '../../../store/rundown.store'
import { runnerStateAtom } from '../../../store/runner.store'
import { RunnerState } from '@rundown-studio/types'
import * as logger from '../../../utils/logger'
import { safeRequestIdleCallback } from '@/shared/lib/safe-request-idle-callback'

const FloatingCountdownButton = lazy(
  () =>
    import('../../../components/rundown/timing/FloatingCountdownButton.jsx'),
)

export const NextHardStartCueOverlay = () => {
  const rundown = useAtomValue(rundownAtom)
  const runnerState = useAtomValue(runnerStateAtom)
  const nextHardStartCueId = useAtomValue(nextHardStartCueIdAtom)
  const firstCueId = useAtomValue(firstCueIdAtom)
  const cues = useAtomValue(cuesAtom)

  const cue = useMemo(() => {
    if (!nextHardStartCueId) return

    return cues[nextHardStartCueId]
  }, [cues, nextHardStartCueId])
  const runningCueId = useMemo(() => {
    if (!cue) return

    return cue.id
  }, [cue])

  const handleScrollIntoView = useCallback(() => {
    if (!runningCueId) return

    const cueElement = document.getElementById(runningCueId)

    logger.info('[NextHardStartCueOverlay] scrolling to cue', cueElement)

    safeRequestIdleCallback(
      () => {
        cueElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      },
      { timeout: 500 },
    )
    // scrollToVirtualIndex(runningCueIndex)
  }, [runningCueId])

  if (runnerState === RunnerState.ENDED) return null
  if (!nextHardStartCueId) return null
  if (runningCueId === firstCueId) return null

  return (
    <Suspense>
      <FloatingCountdownButton
        cue={cue}
        timezone={rundown?.timezone}
        onScrollTo={handleScrollIntoView}
      />
    </Suspense>
  )
}
